import * as React from 'react';

/**
 * Minimal scroll container (lightweight stand-in for the Radix ScrollArea).
 * Provides the `ScrollArea` export expected by existing components.
 */
export const ScrollArea = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', children, ...props }, ref) => (
  <div ref={ref} className={`overflow-auto ${className}`} {...props}>
    {children}
  </div>
));
ScrollArea.displayName = 'ScrollArea';

export default ScrollArea;
